var _path, _path2, _g, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNocontent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.25 32.0834V77.9167C96.25 91.6667 89.375 100.833 73.3333 100.833H36.6667C20.625 100.833 13.75 91.6667 13.75 77.9167V32.0834C13.75 18.3334 20.625 9.16669 36.6667 9.16669H73.3333C89.375 9.16669 96.25 18.3334 96.25 32.0834Z",
    fill: "#9B9DAC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1009_1121",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 84,
    height: 92
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.25 32.0834V77.9167C96.25 91.6667 89.375 100.833 73.3333 100.833H36.6667C20.625 100.833 13.75 91.6667 13.75 77.9167V32.0834C13.75 18.3334 20.625 9.16669 36.6667 9.16669H73.3333C89.375 9.16669 96.25 18.3334 96.25 32.0834Z",
    fill: "#9B9DAC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1009_1121)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1009_1121)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 10.5,
    r: 23.5,
    fill: "#00FFF9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1009_1121)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 99.5,
    r: 23.5,
    fill: "#9747FF"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7918 42.3958H75.6252C68.6585 42.3958 63.021 36.7583 63.021 29.7917V20.625C63.021 18.7458 64.5793 17.1875 66.4585 17.1875C68.3377 17.1875 69.896 18.7458 69.896 20.625V29.7917C69.896 32.9542 72.4627 35.5208 75.6252 35.5208H84.7918C86.671 35.5208 88.2293 37.0792 88.2293 38.9583C88.2293 40.8375 86.671 42.3958 84.7918 42.3958Z",
    fill: "#EAEAEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9998 63.0208H36.6665C34.7873 63.0208 33.229 61.4625 33.229 59.5833C33.229 57.7041 34.7873 56.1458 36.6665 56.1458H54.9998C56.879 56.1458 58.4373 57.7041 58.4373 59.5833C58.4373 61.4625 56.879 63.0208 54.9998 63.0208Z",
    fill: "#EAEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3332 81.3542H36.6665C34.7873 81.3542 33.229 79.7959 33.229 77.9167C33.229 76.0375 34.7873 74.4792 36.6665 74.4792H73.3332C75.2123 74.4792 76.7707 76.0375 76.7707 77.9167C76.7707 79.7959 75.2123 81.3542 73.3332 81.3542Z",
    fill: "#EAEAEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1009_1121",
    x: -83.7,
    y: -87.7,
    width: 196.4,
    height: 196.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.35,
    result: "effect1_foregroundBlur_1009_1121"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1009_1121",
    x: -2.7,
    y: 1.3,
    width: 196.4,
    height: 196.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.35,
    result: "effect1_foregroundBlur_1009_1121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNocontent);
export default __webpack_public_path__ + "static/media/nocontent.f6b6783d8e9636c7ec84ab970bda4597.svg";
export { ForwardRef as ReactComponent };